export default __webpack_public_path__ + "static/article-how-to-improve-the-value-of-your-car-7cd7b9978e08e99b293ed270a8526fe3.jpg";